<template>
	<div>
		<section class="row">
			<div class="col-md-6">
				<div>
					<h3 class="page-title mb-1">
						{{ this.$route.meta.title }}
					</h3>
				</div>
			</div>
			<div class="col-md-6 relative">

			</div>
		</section>
		<section class="tpui-container">
			<div class="row align-items-center mb-4">
				<div class="col-md-12">
					<div class="grey-box p-3 pt-4">
						<div class="row">
							<div class="col-md-6 text-left">
								<h5 class="mt-1 mb-3 uk-text-bold"> <i class="fas fa-user mr-2"></i> projects Name </h5>
							</div>
							<div class="col-md-6 text-right">
								<div class="switches-container w-200 uk-position-right" style="margin-right: 10px;">
									<input type="radio" id="active" name="status[type]" value="active" checked="checked"
										onclick="companyType()" required />
									<input type="radio" id="inactive" name="status[type]" value="inactive"
										onclick="companyType()" required />
									<label for="active" id="lbl_active"> Active </label>
									<label for="inactive" id="lbl_inactive"> Inactive </label>
									<div class="switch-wrapper">
										<div class="switch">
											<div id="lbl_active"> Active </div>
											<div id="lbl_inactive"> Inactive </div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="view-ui mt-2">
							<div class="row">
								<div class="col-md-3 relative pb-5">
									<div class="profile-img position-relative text-center">
										<span class="edit-btn">
											<input type="file" name="company-img" class="file-upload" id="file"
												ref="file" v-on:change="handleFileUpload()" />
											<i class="fal fa-pen upload-button"></i> Change
										</span>
										<img :src="projects.image" alt="Border pill" uk-cover>
									</div>
									<div class="col-md-9">
									</div>
								</div>
								<div class="col-md-9">
									<div class="p-3">
										<div class="row p-0 pb-0">
											<!-- <div class="col-md-4">
													<div class=" form-group">
														<span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: user"></span>
														<input class="uk-input w-100" type="text" value="admin">
														<label>Account Username</label>
													</div>
												</div>
												<div class="col-md-4">
													<div class=" form-group">
														<span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: lock"></span>
														<input class="uk-input w-100" type="password" value="password">
														<label>Password</label>
													</div>
												</div> -->
											<div class="col-md-4">

											</div>
											<div class="col-md-4">

											</div>
											<div class="col-md-4">

											</div>
										</div>
										<div class="row p-0 pb-0 pt-2">
											<div class="col-md-4">
												<div class="form-group">
													<input type="text" name="category" v-model="projects.category"
														class="form-control" value="Favorite" required>
													<label>Category</label>
												</div>
											</div>
											<div class="col-md-4">
												<div class="form-group">
													<input type="text" name="name" v-model="projects.name"
														class="form-control" value="ZZ" required>
													<label>Name</label>
												</div>
											</div>

											<div class="clearfix"></div>
											<div class="col-md-12 mt-3 pl-3 pb-0 mb-0">
												<h6 class="uk-text-uppercase" style="color: #a5a5a5;"> Info </h6>
											</div>

											<div class="col-md-4">
												<div class="form-group">
													<input type="text" name="description" v-model="projects.description"
														class="form-control" value="Notes" required>
													<label> Description </label>
												</div>
											</div>
											<div class="col-md-4">
												<div class="form-group">
													<input type="text" name="url" v-model="projects.url_link"
														class="form-control" value="https://zz-softwaresolutions.com/"
														required>
													<label> URL Link </label>
												</div>
											</div>


											<div class="col-md-4 text-right pt-1">
												<div role="group" aria-label="Basic example" class="btn-group mt-2">
													<button @click="cancel()" class="cancel-btn border-0"><i
															class="fas fa-minus-circle mr-2" aria-hidden="true"></i>
														Cancel </button>
													<button v-if="projects.category!=''" id="client"
														@click="saveContent()" class="save-btn border-0 ml-2 mr-2"><i
															class="fas fa-save mr-2" aria-hidden="true"></i>
														Save</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>

		</section>
	</div>
</template>
<script>
import FirebaseCrud from ".././Firebase/services/FirebaseCrud";
import FirebaseStorage from ".././Firebase/services/FirebaseStorage";

export default {
	data() {
		return {
			projects: {
				category: '',
				description: '',
				name: '',
				image: 'https://firebasestorage.googleapis.com/v0/b/bookmark-any.appspot.com/o/Images%2FPasswordsimages%2F1717515741840-bookmark.jpeg?alt=media&token=16303ce3-5eb7-40a9-b1fe-09368ddcb6c2?alt=media&token=16303ce3-5eb7-40a9-b1fe-09368ddcb6c2/i.pinimg.com/736x/6e/b7/16/6eb7167adfe400aa0d8d581b605f5ef1.jpg',
				update_at: '',
				url_link: '',
				secure: 0,

			},
			firstload: false
		};
	},
	methods: {
		cancel(){
			UIkit.modal.confirm('Aalis ka?').then(
			function () {
				location.href = "/projects"
			},
			function () {
			console.log('Rejected.')
			},
		)
			
		},
		saveContent() {
			var currentDT = "";
			var updated = "";
			let path = "/projects/content/" + atob(this.$route.params.id)
			var today = new Date();
			var dd = today.getDate();
			var mm = today.getMonth() + 1; //January is 0!
			var min = today.getMinutes();
			var ss = today.getSeconds();
			var hh = today.getHours();
			var yyyy = today.getFullYear();
			if (dd < 10) {
				dd = '0' + dd;
			}
			if (mm < 10) {
				mm = '0' + mm;
			}
			currentDT = yyyy + "-" + mm + "-" + dd + "-" + hh + "-" + min + "-" + ss;
			updated = yyyy + "-" + mm + "-" + dd + " " + hh + "-" + min + "-" + ss;
			if (atob(this.$route.params.id) == "new") {
				path = "/projects/content/" + this.projects.category + "/" + currentDT
			}


			let projects = {
				category: this.projects.category,
				description: this.projects.description,
				image: localStorage.getItem("uploadedimage"),
				name: this.projects.name,
				secure: this.projects.secure,
				update_at: currentDT,
				url_link: this.projects.url_link,
			}
			FirebaseCrud.creatContent(path, projects)
			location.href = "/projects"
		},
		onDataChange(items) {
			if (this.firstload == false) {
				this.firstload = true
				items.forEach((item) => {
					let key = item.key;
					this.projects[key] = item.val()
					if (key == "image") {
						localStorage.setItem("uploadedimage", item.val())
					}
				});
			}
		},
		encode(id) {
			return btoa(id)
		},
		handleFileUpload() {
			this.file = this.$refs.file.files[0]
			this.projects.image = URL.createObjectURL(this.file)
			FirebaseStorage.upload("projectsimage", this.file);

		}
	},
	mounted() {
		FirebaseCrud.checkUser()
		if (atob(this.$route.params.id) == "new") {

		} else {
			let path = "/projects/content/" + atob(this.$route.params.id)
			FirebaseCrud.getContent(path).on("value", this.onDataChange);
		}

	},
	beforeUnmount() {
		if (atob(this.$route.params.id) == "new") {

		} else {
			let path = "/projects/content/" + atob(this.$route.params.id)
			FirebaseCrud.getContent(path).on("value", this.onDataChange);
		}
	}
};
</script>







<style scoped>